export default [
  {
    city: 'San Francisco',
    airport: 'SFO',
  },
  {
    city: 'Wellington',
    airport: 'WLG',
  },
  {
    city: 'Sapporo',
    airport: 'CTS',
  },
  {
    city: 'New York',
    airport: 'JFK',
  },
  {
    city: 'Tokyo',
    airport: 'HND',
  },
  {
    city: 'San Torini',
    airport: 'JTR',
  },
  {
    city: 'San Diego',
    airport: 'SAN',
  },
  {
    city: 'Samoa',
    airport: 'APW',
  },
  {
    city: 'Sydney',
    airport: 'SYD'
  },
  {
    city: 'Los Angeles',
    airport: 'LAX',
  },
  {
    city: 'Las Vegas',
    airport: 'LAS',
  },
  {
    city: 'London',
    airport: 'LHR',
  },
  {
    city: 'Munich',
    airport: 'MUC',
  },
  {
    city: 'Brisbane',
    airport: 'BNE',
  },
  {
    city: 'Auckland',
    airport: 'AKL',
  },

  {
    city: 'Christchurch',
    airport: 'CHC',
  },
];
